export { federatedComponent, getOrCreateFederatedComponentCtx, federatedComponentsContext, FederatedComponent } from "./federated-component";
export { default as FederationBoundary } from "./federation-boundary";
export { default as withFederationPrerender } from "./with-federation-prerender";
export { createFederatedCatchAll, matchFederatedPage } from "./federation-catchall";

// used to load remote containers from another application
export const loadJsFileAsync = async filePath => {
  return new Promise((resolve, reject) => {
    var _filePath$split;
    // check if a js file for this remote already exists
    const id = (filePath === null || filePath === void 0 ? void 0 : (_filePath$split = filePath.split("?")) === null || _filePath$split === void 0 ? void 0 : _filePath$split[0]) || filePath;
    // should instead look for data-webpack attribute
    if (!document.getElementById(id)) {
      var script = document.createElement("script");
      script.onload = function () {
        // should use data-webpack="remoteName" instead so webpack can track it
        script.attributes["data-loaded"] = "true";
        resolve();
      };
      script.onerror = function (err) {
        reject(err);
      };
      script.type = "text/javascript";
      script.src = filePath;
      script.id = id;
      document.getElementsByTagName("head")[0].appendChild(script);
    } else {
      // file processed, but check to see it actually loaded
      var s1 = document.getElementById(id);
      var loadedAttribute = s1.attributes["data-loaded"] === "true";
      if (loadedAttribute) {
        resolve();
      } else {
        // add event listeners (in addition to the existing ones)
        s1.addEventListener("load", function () {
          resolve();
        });
        s1.addEventListener("error", function (err) {
          reject(err);
        });
      }
    }
  });
};